/* eslint-disable default-param-last */
import {
  SET_DATA_FOR_ARS_MODAL,
  SET_ERROR_FOR_ARS_MODAL,
  SET_LOADING_FOR_ARS_MODAL,
  SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL,
} from '../types';

const INITIAL_STATE = {
  isOpen: false,
  isLoading: true,
  arsTaskPayload: null,
  arsData: null,
  isError: false,
  error: null,
};

const accessRequestHistoryReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL:
      return {
        ...state,
        ...action?.payload,
      };

    case SET_LOADING_FOR_ARS_MODAL:
      return {
        ...state,
        isLoading: action?.payload,
      };

    case SET_ERROR_FOR_ARS_MODAL:
      return {
        ...state,
        ...action?.payload,
      };

    case SET_DATA_FOR_ARS_MODAL:
      return {
        ...state,
        arsData: action?.payload,
      };

    default:
      return state;
  }
};

export default accessRequestHistoryReducer;
